var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModuleWrapper',{attrs:{"instance":_vm.instance,"backgroundColor":_vm.backgroundColor}},[_c('div',{class:[`${_vm.$appPrefix}-rechtliche-klausel-footer`]},[_c('MgsContainer',[_c('MgsRow',[_c('MgsCol',{attrs:{"sm":12}},[_c('h2',[_vm._v("Rechtliche Klausel Footer")])])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }